import React, { useEffect, useState } from "react";
import AdminNavbar from "../../components/admin_navbar";
import AdminSideMenu from "../../components/admin_side_menu";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { Link } from "react-router-dom";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Analytics = () => {
  const navigate = useNavigate();
  var apiBaseURL = process.env.REACT_APP_API_BASE_URL;

  const [salesCount, setSalesCount] = useState(0);
  const [invoicesCount, setInvoicesCount] = useState(0);
  const [creditNotesCount, setCreditNotesCount] = useState(0);
  const [customersCount, setCustomersCount] = useState(0);
  const [storesCount, setStoresCount] = useState(0);
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });

  useEffect(() => {
    let accessToken = localStorage.getItem("strutspos_access_token");
    if (!accessToken) {
      navigate("/");
    }

    window.scrollTo(0, 0);
    getDashboardAnalytics();
  }, [apiBaseURL, navigate]);

  const getDashboardAnalytics = async () => {
    var accessToken = localStorage.getItem("strutspos_access_token");

    try {
      const res = await axios({
        url: apiBaseURL + "/analytics",
        headers: {
          "x-strutspos-token": accessToken,
          "x-strutspos-application": "user",
        },
        method: "GET",
      });

      let dashboardAnalytics = JSON.parse(JSON.stringify(res.data));
      setCreditNotesCount(dashboardAnalytics.total_credit_notes_count);
      setInvoicesCount(dashboardAnalytics.total_invoices_count);
      setCustomersCount(dashboardAnalytics.customers_count);
      setStoresCount(dashboardAnalytics.stores_count);

      let chartSummariesData = dashboardAnalytics.chart_summary;

      setChartData({
        labels: chartSummariesData.map((data) => data.month),
        datasets: [
          {
            label: "Total Sales",
            data: chartSummariesData.map((data) => data.total_sales),
            backgroundColor: "rgba(99, 102, 241, 0.8)",
            borderColor: "rgba(99, 102, 241, 1)",
            borderWidth: 1,
            borderRadius: 8,
          },
        ],
      });
    } catch (err) {
      console.error("getDashboardAnalytics err = " + err.message);
    }
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          font: {
            size: 14,
            weight: "500",
          },
          color: "#64748b",
        },
      },
      title: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: "#f1f5f9",
        },
        ticks: {
          color: "#64748b",
          font: {
            size: 12,
          },
        },
      },
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: "#64748b",
          font: {
            size: 12,
          },
        },
      },
    },
  };

  return (
    <div className="modern-admin-layout">
      <AdminNavbar />

      <div className="admin-container">
        <div className="admin-sidebar">
          <AdminSideMenu />
        </div>

        <main className="admin-main-content">
          {/* Modern Analytics Header */}
          <div className="dashboard-header-modern">
            <div className="dashboard-header-content">
              <h1 className="dashboard-title">Analytics</h1>
              <p className="dashboard-subtitle">
                Business insights and performance metrics
              </p>
            </div>
          </div>

          {/* Analytics Stats Grid */}
          <div className="modern-stats-grid">
            <Link to="/invoices" className="modern-stat-card primary">
              <div className="stat-card-header">
                <div className="stat-icon primary">
                  <span>�</span>
                </div>
                <div className="stat-trend up">
                  <span>↗ +12.5%</span>
                </div>
              </div>
              <div className="stat-content">
                <div className="stat-value">
                  {invoicesCount.toLocaleString()}
                </div>
                <div className="stat-label">Total Invoices</div>
              </div>
            </Link>

            <Link to="/credit-notes" className="modern-stat-card success">
              <div className="stat-card-header">
                <div className="stat-icon success">
                  <span>�</span>
                </div>
                <div className="stat-trend down">
                  <span>↘ -2.1%</span>
                </div>
              </div>
              <div className="stat-content">
                <div className="stat-value">
                  {creditNotesCount.toLocaleString()}
                </div>
                <div className="stat-label">Credit Notes</div>
              </div>
            </Link>

            <Link to="/stores" className="modern-stat-card info">
              <div className="stat-card-header">
                <div className="stat-icon info">
                  <span>🏪</span>
                </div>
                <div className="stat-trend up">
                  <span>↗ +5.0%</span>
                </div>
              </div>
              <div className="stat-content">
                <div className="stat-value">{storesCount.toLocaleString()}</div>
                <div className="stat-label">Active Stores</div>
              </div>
            </Link>

            <Link to="#" className="modern-stat-card warning">
              <div className="stat-card-header">
                <div className="stat-icon warning">
                  <span>�</span>
                </div>
                <div className="stat-trend up">
                  <span>↗ +8.3%</span>
                </div>
              </div>
              <div className="stat-content">
                <div className="stat-value">
                  {customersCount.toLocaleString()}
                </div>
                <div className="stat-label">Total Customers</div>
              </div>
            </Link>
          </div>

          {/* Charts Section */}
          <div className="charts-section-modern">
            <div className="chart-card-modern">
              <div className="chart-header-modern">
                <div className="chart-title-section">
                  <h3>Sales Overview</h3>
                  <p>Monthly sales performance</p>
                </div>
                <div className="chart-actions">
                  <select className="modern-select">
                    <option>Last 12 months</option>
                    <option>Last 6 months</option>
                    <option>Last 3 months</option>
                  </select>
                </div>
              </div>
              <div className="chart-container-modern">
                {chartData.labels.length > 0 ? (
                  <Bar data={chartData} options={chartOptions} />
                ) : (
                  <div className="chart-loading">Loading chart data...</div>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Analytics;
